/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Finals_Seating_Procedure_LinkInputs */



/**
* | output |
* | --- |
* | "Tournament Rules 3.1.3" |
*
* @param {Finals_Seating_Procedure_LinkInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const finals_seating_procedure_link = /** @type {((inputs?: Finals_Seating_Procedure_LinkInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Finals_Seating_Procedure_LinkInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Tournament Rules 3.1.3")
	if (locale === "es") return /** @type {LocalizedString} */ ("Tournament Rules 3.1.3")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Tournament Rules 3.1.3")
	if (locale === "it") return /** @type {LocalizedString} */ ("Tournament Rules 3.1.3")
	return /** @type {LocalizedString} */ ("Tournament Rules 3.1.3")
});